import {Avatar} from '@material-ui/core';
import {MOON_150} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const AvatarImage = styled(Avatar)`
  && {
    width: 24px;
    height: 24px;
  }
  margin-right: 4px;
  img {
    object-fit: contain;
  }
`;
AvatarImage.displayName = 'S.AvatarImage';

export const EntityChip = styled.div`
  display: inline-flex;
  align-items: center;
  margin: 0 4px;
  background-color: ${MOON_150};
  height: 24px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 18px;
  padding: 3px 8px 3px 0;
`;
EntityChip.displayName = 'S.EntityChip';
